import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { EditUserDetails } from './components/edit-user-details/component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserApiService } from './services/user-api.service';
import { EditOrganisations } from './components/edit-organisations/component';
import { ResetUserPassword } from './components/reset-user-password/component';
import { EditGroups } from './components/edit-groups/component';
import { UserExportService } from './services/user-export-service';
import { GenerateUserPassword } from './components/generate-user-password/component';
import { EditUserAddresses } from './components/edit-user-addresses/component';
import { DeleteAddressConfirm } from './components/delete-address-confirm/component';

@NgModule({
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
  exports: [EditUserDetails, EditOrganisations, EditGroups, EditUserAddresses],
  declarations: [
    EditUserDetails,
    EditOrganisations,
    EditGroups,
    ResetUserPassword,
    GenerateUserPassword,
    EditUserAddresses,
    DeleteAddressConfirm,
  ],
  providers: [UserApiService, UserExportService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class UserModule {}
